module.exports = __webpack_public_path__ + "basic_name.svg?db7a75bb787de7835fb0ed0835f264c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/basic_name.svg
// module id = 15
// module chunks = 0